var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role == 'Z')?[_c('z',{on:{"nextBtn":_vm.nextBtn}})]:[_c('d')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }